<template>
  <button
    type="button"
    class="lang-switch"
    :title="locale === 'en' ? 'Switch to German' : 'Switch to English'"
    :aria-label="locale === 'en' ? 'Switch to German' : 'Switch to English'"
    @click="toggleLocale"
  >
    <svg class="lang-flag" viewBox="0 0 24 16" width="22" height="15" aria-hidden="true">
      <rect width="24" height="5.33" fill="#000" />
      <rect y="5.33" width="24" height="5.33" fill="#DD0000" />
      <rect y="10.67" width="24" height="5.33" fill="#FFCE00" />
    </svg>
    <span class="lang-code">{{ locale === 'en' ? 'DE' : 'EN' }}</span>
  </button>
</template>

<script setup>
import { useLocale } from '../composables/useLocale.js';

const { locale, toggleLocale } = useLocale();
</script>

<style scoped>
.lang-switch {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 10px;
  border: 1px solid var(--border);
  border-radius: 999px;
  background: var(--bg);
  cursor: pointer;
  font-family: inherit;
  font-size: 11px;
  font-weight: 600;
  color: var(--fg-soft);
  transition:
    border-color 120ms ease,
    background 120ms ease;
}
.lang-switch:hover {
  border-color: var(--border-strong);
  background: var(--bg-elev);
}
.lang-flag {
  border-radius: 2px;
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.08);
}
.lang-code {
  letter-spacing: 0.06em;
}
</style>
